export let ETooltipViewType = /*#__PURE__*/function (ETooltipViewType) {
  ETooltipViewType[ETooltipViewType["Popper"] = 0] = "Popper";
  ETooltipViewType[ETooltipViewType["Modal"] = 1] = "Modal";
  return ETooltipViewType;
}({});